<template>
  <div class="component-content sub-content">
    <div class="list-title no-bottom-border">
      <div class="r">
        <el-button v-if="backRole('AS_1')" type="primary" @click="startCreate()" size="mini">资产入库</el-button>

        <a :href="baseURL+'/asset/list/download?depId='+form.depId+'&assetDeptId='+form.assetDeptId+'&classifyId='+form.classifyId+'&name='+form.name+'&number='+form.number+'&spec='+form.spec+'&user='+form.user+'&zrUser='+form.zrUser+'&cwUser='+form.cwUser+'&rzTimeStart='+form.rzTimeStart+'&rzTimeEnd='+form.rzTimeEnd+'&status='+form.status"
          target="_blank">
          <el-button type="primary" size="mini">资产实时库存表下载</el-button>
        </a>
      </div>
      <label class="label-name">所属公司：</label>
      <el-select size="small" :disabled="noSelectOrganization" class="organization-select" v-model="form.depId"
        placeholder="请选择所属公司">
        <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </div>

    <!-- <div class="list-title">
      <el-row>
        <el-col :span="8">
          <el-input v-model="filterKey" size="mini" placeholder="你可以输入筛选资产编号/资产名称进行筛选"></el-input>
        </el-col>
      </el-row>
    </div> -->

    <div class="list-title" style="padding:5px 10px 8px;background:#f8f8f8;">
      <!-- 条件搜索 -->
      <h3 class="title" style="float:none;border-bottom:1px #ccc solid;margin-bottom:5px;">
        条件搜索
        <span class="tip" style="font-size:12px;">（搜索条件为选填, 然后点击搜索按钮进行搜索）</span>
      </h3>
      <section style="font-size:12px;">
        <div class="filter-item" style="margin-bottom:5px;">
          <label class="label-name">所属部门：</label>
          <el-select size="mini" clearable style="width:120px;" class="organization-select" v-model="form.assetDeptId"
            placeholder="请选择所属部门">
            <el-option v-for="item in childDeptList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
          <label class="label-name ml5px">分类：</label>
          <asset-type Tsize="mini" :a="type.a?type.a:''" :b="type.b?type.b:''" :c="type.c?type.c:''"
            :d="type.d?type.d:''" ref="assetType" />
        </div>
        <div class="filter-item" style="margin-bottom:5px;">
          <label class="label-name">入账时间：</label>
          <span style="width:120px;display:inline-block;">
            <el-date-picker v-model="form.rzTimeStart" size="small" value-format="yyyy-MM-dd" type="date"
              style="width:100%!important;" placeholder="开始时间"></el-date-picker>
          </span>
          <label class="label-name">至</label>
          <span style="width:120px;display:inline-block;">
            <el-date-picker v-model="form.rzTimeEnd" size="small" value-format="yyyy-MM-dd" type="date"
              style="width:100%!important;" placeholder="结束时间"></el-date-picker>
          </span>

          <label class="label-name ml5px">资产编号：</label>
          <span style="width:110px;display:inline-block;">
            <el-input size="mini" type="number" v-model="form.number"></el-input>
          </span>
          <label class="label-name ml5px">资产名称：</label>
          <span style="width:110px;display:inline-block;">
            <el-input size="mini" v-model="form.name"></el-input>
          </span>
          <label class="label-name ml5px">规格型号：</label>
          <span style="width:110px;display:inline-block;">
            <el-input size="mini" type="" v-model="form.spec"></el-input>
          </span>
        </div>
        <div class="filter-item" style="margin-bottom:5px;">
          <label class="label-name">使用人：</label>
          <span style="width:120px;display:inline-block;">
            <el-input size="mini" type="" v-model="form.user"></el-input>
          </span>
          <label class="label-name ml5px">负责人：</label>
          <span style="width:120px;display:inline-block;">
            <el-input size="mini" type="" v-model="form.zrUser"></el-input>
          </span>
          <label class="label-name ml5px">财务负责人：</label>
          <span style="width:120px;display:inline-block;">
            <el-input size="mini" type="" v-model="form.cwUser"></el-input>
          </span>
          <label class="label-name ml5px">资产状态：</label>
          <span style="width:120px;display:inline-block;">
            <el-select size="mini" clearable style="width:120px;" v-model="form.status"
            placeholder="选择资产状态">
            <el-option v-for="item in accessStatusSelect" :key="item.type" :label="item.value" :value="item.type">
            </el-option>
          </el-select>
            <!-- <el-input size="mini" type="" v-model="form.cwUser"></!--> 
          </span>

          <el-button type="success" @click="getFilterData()" style="margin-left:5px;" size="mini">搜索筛选结果</el-button>
          <el-button type="primary" @click="resetFilterData()" style="margin-left:5px;" size="mini">重置</el-button>
        </div>
      </section>
    </div>

    <div class="table-total" v-if="paginationData">
      <ul class="total-ul th-ul">
        <li v-for="item,i in hjsData" :key="i">
          <label>{{ item.status }}</label>
          <div class="cont">
            <span>购置金额：{{ item.priceTotal }}</span>
            <span>净值：{{ item.jzTotal }}</span>
            <span>累计折旧：{{ item.ljzjTotal }}</span>
          </div>
        </li>
      </ul>
    </div>
    <el-table border :data="paginationData" style="width: 100%" v-loading="loading"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="25px">
      </el-table-column>
      <el-table-column prop="number" label="资产编号" width="120px">
      </el-table-column>
      <el-table-column label="资产名称">
        <template slot-scope="scope">
          <span :style="(scope.row.status!='10'&&scope.row.status!='11')?'':'color:#f00'">
            {{ "("+accessStatus[scope.row.status]+") "+scope.row.name }}
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="attribute.name" label="资产属性" width="90px">
      </el-table-column> -->
      <el-table-column prop="spec" label="规格型号" width="130px">
      </el-table-column>
      <!-- <el-table-column prop="manufacturer" label="制造厂商">
      </el-table-column> -->
      <el-table-column prop="" label="购置金额" width="90px" align="center">
        <template slot-scope="scope">
          {{ scope.row.price && parseFloat(scope.row.price).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="jz" label="净值" width="90px" align="center">
      </el-table-column>
      <el-table-column prop="ljzj" label="累计折旧" width="90px" align="center">
      </el-table-column>
      <el-table-column prop="" label="残值" width="70px" align="center">
        <template slot-scope="scope">
          {{ scope.row.cz && parseFloat(scope.row.cz).toFixed(2) }}
        </template>
      </el-table-column>
      <!-- <el-table-column prop="amount" label="数量" width="60px" align="center">
      </el-table-column> -->
      <el-table-column prop="purchaseTime" label="购置时间" width="80px">
      </el-table-column>


      <el-table-column label="操作" width="100px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="点击查看详情" placement="bottom">
            <i @click="assetDetail(scope.row)" class="iconfont icon-157 meeting-btn-icon"></i>
          </el-tooltip>
          <el-tooltip v-if="backRole('AS_1')" class="item" effect="dark" content="点击变更信息" placement="bottom">
            <i @click="assetChange(1, scope.row)" class="iconfont icon-xiugai meeting-btn-icon  mbi-edit"></i>
          </el-tooltip>
          <!-- <el-tooltip class="item" effect="dark" content="点击进行维修" placement="bottom">
            <i @click="assetRepair(1, scope.row)" class="iconfont icon-157 meeting-btn-icon"></i>
          </el-tooltip> -->
          <el-tooltip v-if="backRole('AS_1')" class="item" effect="dark" content="点击删除" placement="bottom">
            <i @click="assetDelete(scope.row)" class="iconfont icon-close meeting-btn-icon mbi-remove"></i>
          </el-tooltip>

          <!-- <el-button plain size="mini" @click="assetChange(1, scope.row)">变更</el-button>
          <el-button plain size="mini" @click="assetRepair(1, scope.row)">维修</el-button>
          <el-button plain size="mini" type="danger" @click="assetDelete(scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>

    <div class="tool-box" v-if="backRole('AS_1')">
      <el-button type="primary" size="mini" @click="assetChange(2)">变更资产信息</el-button>
      <el-button type="primary" size="mini" @click="assetRepair(2)">资产维修</el-button>
      <el-button type="primary" size="mini" @click="assetHandle(2)">资产处置</el-button>
      <!-- <el-button type="primary" size="mini" @click="">领用/退库</el-button>
      <el-button type="primary" size="mini" @click="">借用/归还</el-button> -->
      <!-- <el-button type="primary" size="mini" @click="">资产处理</el-button> -->
    </div>

    <el-pagination style="margin-left:-5px;" v-if="pageTotal>form.pageSize" class="list-pagination" background
      :page-size="form.pageSize" :pager-count="9" :current-page="form.page+1" layout="pager" :total="pageTotal"
      @current-change="handleCurrentChange">
    </el-pagination>

    <asset-detail></asset-detail>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import Role from '@/Mixins/role'
  import AssetDetail from './assetDetail'
  import AssetType from './components/type'
  export default {
    mixins: [Role],
    components: {
      AssetDetail,
      AssetType,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        baseURL: axios.defaults.baseURL,

        organizationListData: [],
        noSelectOrganization: true,
        // depId: '',
        accessStatus: ["闲置中", "使用中", "维修中", "正常报废", "非正常报废", "损毁", "出售", "其他", "盘盈", "盘亏", "即将过期", "过期"],
        accessStatusSelect:[{
          type: 0,
          value:'闲置中'
        },{
          type: 1,
          value:'使用中'
        },{
          type: 2,
          value:'维修中'
        },{
          type: 10,
          value:'即将过期'
        },{
          type: 11,
          value:'已过期'
        }],

        form: {
          assetDeptId: '',
          depId: '',
          classifyId: '',
          name: '',
          number: '',
          spec: '',
          user: '',
          zrUser: '',
          cwUser: '',
          rzTimeStart: '',
          rzTimeEnd: '',
          page: 0,
          pageSize: 20,
          status:'',
        },
        type: {
          a: '',
          b: '',
          c: '',
          d: '',
        },
        childDeptList: [],

        // 列表
        loading: true,
        pageTotal: 0,
        hjsData: [],
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        teamId: 0,
        filterKey: "",
        teamArr: [],

        // 表格多选
        multipleSelection: []
      }
    },
    mounted() {
      console.log(this.organization.length > 0)

      // this.organizationListData.push({
      //   id: 0,
      //   name: "集团所有公司",
      //   depId: 0
      // })
      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = this.organizationListData.concat(_or)

      this.form.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.form.depId == "7" || this.backRole('SYSTEM_1')) {
        this.noSelectOrganization = false
        // this.form.depId = 0
      }

      // 获取子机构目录
      this.getChildDeptList()
      // 获取项目组
      // this.getTeam()
    },
    methods: {

      // 获取子机构目录
      getChildDeptList() {
        ajax.get('/dept/child/list', {
          depId: this.form.depId
        }, (res) => {
          this.childDeptList = res.vo.array
        })
      },
      // 资产处置
      assetHandle(type, row) {
        let handle = {
          type: type,
          data: []
        }

        switch (type) {
          case 1:
            handle.data.push(row)
            break;
          case 2:
            if (this.multipleSelection.length < 1) {
              this.$message.error("请先选择资产，再进行资产处置")
              return
            } else if (this.multipleSelection.length == 1) {
              handle.type = 1
            }
            handle.data = this.multipleSelection
            break;
        }
        this.$store.commit('set_assetHandle', handle)
        this.$router.push('/Asset/Handle')
      },
      // 资产维修
      assetRepair(type, row) {
        let repair = {
          type: type,
          data: []
        }

        switch (type) {
          case 1:
            repair.data.push(row)
            break;
          case 2:
            if (this.multipleSelection.length < 1) {
              this.$message.error("请先选择资产，再进行资产维修")
              return
            } else if (this.multipleSelection.length == 1) {
              repair.type = 1
            }
            repair.data = this.multipleSelection
            break;
        }
        this.$store.commit('set_assetRepair', repair)
        this.$router.push('/Asset/Repair')
      },
      // 资产变更
      assetChange(type, row) {
        let change = {
          type: type,
          data: []
        }

        console.log(row)

        switch (type) {
          case 1:
            change.data.push(row)
            break;
          case 2:
            if (this.multipleSelection.length < 1) {
              this.$message.error("请先选择资产，再进行资产信息变更")
              return
            } else if (this.multipleSelection.length == 1) {
              change.type = 1
            }
            change.data = this.multipleSelection
            break;
        }
        this.$store.commit('set_assetChange', change)
        this.$router.push('/Asset/Edit')
      },
      // 多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      // 删除
      assetDelete(row) {
        this.$confirm('此操作将永久删除该资产, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          ajax.post('/asset/del/' + row.id, {}, (res) => {
            this.$message.success('删除资产成功')
            this.getLists()
          })
        }).catch(() => {});
      },
      // 显示详情
      assetDetail(row) {
        let assetChangeDetail = {
          status: false,
          data: {}
        }
        this.$store.commit('set_assetChangeDetail', assetChangeDetail)

        let assetDetail = {
          status: true,
          data: row
        }
        // console.log(assetDetail)
        this.$store.commit('set_assetDetail', assetDetail)
      },
      // 新建
      startCreate() {
        this.$router.push("/Asset/Create")
      },

      // 当前页
      handleCurrentChange(val) {
        this.form.page = val - 1
        this.getLists()
      },
      // 重置
      resetFilterData() {
        this.form.assetDeptId = ''
        this.form.classifyId = ''
        this.form.name = ''
        this.form.number = ''
        this.form.spec = ''
        this.form.user = ''
        this.form.zrUser = ''
        this.form.cwUser = ''
        this.form.page = 0
        this.form.pageSize = 20

        this.$refs.assetType.resetType()

        // 获取符合条件的列表
        this.getLists()
      },
      // 搜索筛选数据
      getFilterData() {
        this.form.page = 0

        let _classifyId = this.$refs.assetType.getAddress()
        _classifyId = _classifyId ? _classifyId : ''
        this.form.classifyId = _classifyId
        // 获取符合条件的列表
        this.getLists()
      },
      // 分页筛选数据
      getPaginationData() {
        this.paginationData = this.filterData
      },
      // 获取列表
      getLists() {
        this.loading = true
        ajax.get('/asset/list', this.form, (res) => {
          this.loading = false
          this.filterData = this.listData = res.vo.list
          this.hjsData = res.vo.hjs
          this.pageTotal = res.vo.size
          this.getPaginationData()
        })
      },
    },
    watch: {
      'form.depId'() {
        this.resetFilterData()
        this.getChildDeptList()
        this.getLists()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/list.vue